import React from 'react';

import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import styles from './styles.module.scss';

type ImageContentProps = {
  image: {
    url: string;
  };
  altText: string;
  editMode?: boolean;
  isPreviewMode: boolean;
  containerRef?: React.RefObject<HTMLDivElement>;
};

const ImageContent = ({
  image,
  altText,
  editMode = false,
  isPreviewMode = false,
  containerRef,
}: ImageContentProps): JSX.Element => (
  <div
    ref={containerRef}
    styleName={classNames({
      'image-slide': !isPreviewMode,
      'preview-mode': isPreviewMode,
      edit: editMode,
    })}
    style={
      {
        '--image-url': `url(${image.url})`,
      } as React.CSSProperties
    }
    data-automation={`slide-image${editMode ? '-preview' : ''}`}
    aria-label={altText}
    role='img'
  >
    <img src={image.url} alt='' />
  </div>
);

export default CSSModules(ImageContent, styles, {allowMultiple: true});
